import { RouterParamType } from "@/model/navModel";
import React, { FC, useState } from "react";
import { CreatedTableBox } from "./CreatedTableBox";
import { TableBox } from "./TableBox";


export const Files: FC<RouterParamType> = (detailsInfo) => {

    return (<>
        <TableBox {...detailsInfo} />
        {/* <CreatedTableBox {...detailsInfo} /> */}
    </>
    )
}